import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import SmartphoneRoundedIcon from '@mui/icons-material/SmartphoneRounded';
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded';
import WorkspacePremiumRoundedIcon from '@mui/icons-material/WorkspacePremiumRounded';
import PageLayout from '../components/PageLayout';
import Section, { SectionHeading } from '../components/PageSection';
import { FeatureCard, FeatureIcon, CardTitle, CardText, Lead, accentAt, AccreditationNote } from '../components/ui';

const SITE = 'https://qasc.it';

// Facts from the original /e-learning page only.
const advantages = [
  {
    icon: <ScheduleRoundedIcon />,
    title: 'Le tempistiche le decidi tu',
    text: 'I percorsi formativi possono essere somministrati in ogni momento: le tempistiche di somministrazione della formazione le decidi tu.',
  },
  {
    icon: <SmartphoneRoundedIcon />,
    title: 'Da PC o smartphone',
    text: 'I corsi si seguono usando un PC o un semplice smartphone, ovunque ti trovi.',
  },
  {
    icon: <WorkspacePremiumRoundedIcon />,
    title: 'Attestato in tempi brevissimi',
    text: 'L’emissione del certificato di partecipazione è garantita in tempi brevissimi: appena terminato il corso ricevi il report e l’attestato tramite e-mail.',
  },
];

function ELearningPage() {
  return (
    <PageLayout
      seo={{
        title: 'E-Learning — Formazione Online per Aziende | QAS Consulting',
        description:
          'La piattaforma e-learning di QAS Consulting, implementata con il partner MADE HSE: percorsi formativi fruibili in ogni momento da PC o smartphone, con report e attestato via e-mail appena terminato il corso.',
        canonical: `${SITE}/e-learning`,
      }}
      hero={{
        kicker: 'Formazione · E-Learning',
        title: 'E-Learning',
        subtitle:
          'Per avvicinarsi al cliente a 360°, QAS Consulting ha implementato con il proprio partner MADE HSE una piattaforma per la formazione e-learning con contenuti in continua evoluzione.',
      }}
    >
      {/* (1) Vantaggi */}
      <Section tone="light">
        <Container maxWidth="lg">
          <SectionHeading
            kicker="La piattaforma"
            title="La formazione online per la tua azienda"
            subtitle="Contenuti in continua evoluzione, fruibili quando e dove vuoi."
          />
          <Grid container spacing={4}>
            {advantages.map((m, i) => (
              <Grid item xs={12} md={4} key={m.title}>
                <FeatureCard>
                  <FeatureIcon accent={accentAt(i)}>{m.icon}</FeatureIcon>
                  <CardTitle>{m.title}</CardTitle>
                  <CardText>{m.text}</CardText>
                </FeatureCard>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Section>

      {/* (2) CTA */}
      <Section tone="mist">
        <Container maxWidth="lg">
          <Box sx={{ maxWidth: '760px', mx: 'auto', textAlign: 'center' }}>
            <Lead>
              Vieni a scoprire la nostra offerta formativa e costruisci il percorso su misura per
              te.
            </Lead>
            <Typography
              component={RouterLink}
              to="/contatti"
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                fontFamily: '"Sora", sans-serif',
                backgroundColor: 'primary.main',
                color: '#ffffff',
                px: '30px',
                py: '13px',
                borderRadius: '999px',
                fontWeight: 600,
                fontSize: '15px',
                textDecoration: 'none',
                mt: 2,
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': { backgroundColor: 'primary.dark', transform: 'translateY(-2px)' },
              }}
            >
              Scopri di più
            </Typography>
          </Box>
          <AccreditationNote />
        </Container>
      </Section>
    </PageLayout>
  );
}

export default ELearningPage;
